import React from 'react'
import { Grid } from '@material-ui/core'
import { useTranslation, Trans } from 'react-i18next'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import DazzedParagraph11 from 'components/common/text/DazzedParagraph11'
import RuleExecutionHourInput from './RuleExecutionHourInput'
import usePracticeTimezone from 'hooks/usePracticeTimezone'

// The hour belongs to the schedule, not to any one action, so it is rendered once per rule
// rather than inside each action editor. getRuleExecutionHour on the backend reads the first
// action carrying executionHour, which matches this one-control-per-rule shape.
const RuleExecutionHourField = ({ value, onChange, defaultHour }) => {
  const { t } = useTranslation()
  const { timezoneUtcOffset } = usePracticeTimezone()

  return (
    <Grid container direction="column">
      <Grid item>
        <Grid container spacing={1} alignItems="center">
          <Grid item>
            <DazzedParagraph14 strong>{t('pages.accountSettings.automations.editorModal.runThisAt')}</DazzedParagraph14>
          </Grid>
          <Grid item>
            <RuleExecutionHourInput value={value || ''} onChange={onChange} defaultHour={defaultHour} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ marginTop: 5 }}>
        <DazzedParagraph11>
          <Trans
            i18nKey={'pages.accountSettings.automations.editorModal.executionHourWithTimezone'}
            values={{
              hour: value,
              utcOffset: timezoneUtcOffset
            }}
          />
        </DazzedParagraph11>
      </Grid>
    </Grid>
  )
}

export default RuleExecutionHourField
